export default __webpack_public_path__ + "static/media/darshan.e5e4b22e.jpeg";